import React from 'react';
import { Controller } from 'react-hook-form';
import Chip from '@mui/material/Chip';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

const AutocompleteTextForm = ({ control, dynamicField, errors, required, label }) => {

  return (
    <>
      <Controller
        name={dynamicField}
        control={control}
        defaultValue={[]}
        rules={{
          required: {
            value: required,
            message: 'This field is required',
          }
        }}
        render={({ field: { value, onChange } }) => (
          <Autocomplete
            multiple
            size='small'
            options={[]}
            value={value || []}
            onChange={(event, newValue) => onChange(newValue)}
            freeSolo
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip size="small" label={option} {...getTagProps({ index })} variant="outlined"/>
              ))
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label={label}
                size="small"
                error={!!errors?.[dynamicField]}
                helperText={errors?.[dynamicField]?.message || ''}
              />
            )}
          />
        )}
      />
    </>
  );
};

export default AutocompleteTextForm;
